<template lang="pug">
v-container(v-if="team" fluid px-0 class="tw-px-0 tw-mx-0  tw-h-full ")
  v-row(no-gutters class="tw-pt-10 tw-shrink-0")
    v-col(cols="12")
      kubiqa-misc-logo(:logo="team.logo")
  v-row(no-gutters class="tw-shrink-0")
    v-col(class=" tw-mt-2")
      span {{ $t('Common.welcome') }}!
  v-row(no-gutters class="tw-srhink-0")
    v-col(class="tw-mt-1")
      span(data-e2e="crm-current-team" class=" tw-font-medium tw-text-lg") {{ team.name }}
  v-row(no-gutters class=" tw-h-full tw-max-h-full ")
    v-col(cols="12" class=" tw-max-h-full tw-h-full overflow-hidden")
      kubiqa-activity-sidebar
</template>
<script>
export default {
  computed: {
    team() {
      return this.$store.getters['team/currentTeam'];
    },
  },
  mounted() {
    this.$store.dispatch('team/show');
  },
};
</script>
